export const VALID_EMAIL_REGEX = new RegExp(
  /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/,
);

export const POSITIVE_INTEGER_REGEX = new RegExp("^[1-9]\\d*$");

export const VALID_NAME_REGEX = new RegExp(/^[ \-a-zšđčćžÀ-ÖØ-öø-ÿ]{1,50}$/);

export const PHONE_NUMBER_REGEX = /^\+\d{1,3}\d{9,12}$/;

export const INVOICE_ATTACHMENT_PREFIX = /^[0-9_]{15}/;

export const TALENT_CV_PREFIX = /^[0-9a-zA-Z_-]{52}/;
